export interface ISearchInputValues {
    makeModelYear: string;
    partNumber: string;
    customerItemCode: string;
    itemGroup: string[];
    certCategory: string[];
    modified: boolean;
    modifiedGroups: boolean;
}

interface ISearchItemCertCategoryInfo {
    certCategory: string;
    certCategoryCount: number;
}

interface ISearchItemGroupInfo {
    itemGroup: string;
    itemGroupCount: number;
}

export interface ISearchItemInfo {
    total: number;
    limit: number;
    start: number;
    data: ISearchItem[];
    certCategory: ISearchItemCertCategoryInfo[];
    itemGroup: ISearchItemGroupInfo[];
}

export interface ISearchItemsGroup {
    concat: string;
    make: string;
    model: string;
    fromYear: number;
    toYear: number;
    items: ISearchItem[];
}

export interface ICartItemsGroup {
    concat: string;
    make: string;
    model: string;
    fromYear: number;
    toYear: number;
    items: ICartItem[];
}

export interface ICartInfo {
    total: number;
    limit: number;
    skip: number;
    data: ICartInfoItem[];
    hadMoreThanOneCart: boolean;
}

export interface ICartInfoItem {
    id: number | null;
    name: string | null;
    userId: number | null;
    createdAt: string | null;
    updatedAt: string | null;
    item: ICartItem[];
    totalCount: number | null;
    total: number | null;
    totalListPrice: number | null;
    deleteConfirmation: boolean;
}

export interface ISearchItem {
    id: number;
    itemCode: string;
    itemName: string | null;
    itemClass: string | null;
    image: string | null;
    imageThumb: string | null;
    Partslink: string;
    certCategory: string;
    certification: string;
    custItemCode: string | null;
    dpi: string | null;
    oem: string | null;
    fromYear: number;
    toYear: number;
    listPrice: string;
    price: string;
    make: string;
    model: string;
    docduedate: string | null;
    stockCA?: string;
    stockTX?: string;
    stockVA?: string;
    lines?: IFitment[];
    fitments: IFitment[];
    showFitments?: boolean;
    LocalStock?: string;
    RegionalStock?: string;
}

export interface ICartItem extends ISearchItem {
    quantity: number;
    hidden: boolean;
    stock: {
        [key: string]: ICartItemStockAtWarehouse;
    };
}

export interface ICartItemStockAtWarehouse {
    whsCode: string;
    whsName: string;
    stock: number;
}

export interface IFetchedFitments {
    loading: boolean;
    itemId: number;
    itemCode: string | null;
    fitments: IFitment[];
}

export interface IFitment {
    engineSpec: null;
    fromYear: string;
    itemCode: string;
    make: string;
    model: string;
    oem: string;
    subModels: null;
    toYear: number;
    transType: null;
    variables: string;
}

export interface ISearchFitments {
    total: number;
    limit: number;
    skip: number;
    data: IFitment[];
}

export interface IItemInventoryCount {
    numberCount: number;
    count: number | string | null;
    status: EInventoryStatus;
}

export interface IItemInventory extends IItemInventoryCount {
    code: string;
}

export enum EInventoryStatus {
    JustCount,
    LargerOrEqual,
    SmallerThan,
    Unavailable
}

export interface IItemPrice {
    label: string;
    opensWarehousesLocations: boolean;
    currencySymbol: string | null;
    beforeDecimal: string | null;
    afterDecimal: string | null;
}

export interface ICategoryOrCertificate {
    name: string;
    checked: boolean;
    visible: boolean;
    crossed: boolean;
}

export interface IMakeModelYearSuggestion {
    make: string;
    model: string;
    fromYear: number;
    toYear: number;
}

export interface IMakeModelYearSuggestionsApi {
    data: IMakeModelYearSuggestion[];
    limit: number;
    skip: number;
    total: number;
}

export type ShippingMethod = 'pickup' | 'delivery' | 'ltl' | 'ltlwithliftgate' | 'other';

export interface IOtherShippingTypesApi {
    data: IOtherShippingType[];
    limit: number;
    skip: number;
    total: number;
}

export interface IOtherShippingType {
    id: number;
    name: string;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/search.ts